import React from 'react';

const PlpBackground = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="850"
    height="687"
    viewBox="0 0 850 687"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask id="mask0_181432_11715" maskUnits="userSpaceOnUse" x="0" y="0" width="1049" height="1049">
      <path d="M1049 0H0V1049H1049V0Z" fill="white" />
    </mask>
    <g mask="url(#mask0_181432_11715)">
      <path
        d="M413.674 1036.94C396.404 864.33 625.803 841.367 608.533 668.755"
        stroke="#F8EADD"
        stroke-width="3.68242"
        stroke-miterlimit="10"
      />
      <path
        d="M306.101 1001.12C326.343 828.826 555.322 855.707 575.541 683.417"
        stroke="#F8EADD"
        stroke-width="3.68242"
        stroke-miterlimit="10"
      />
      <path
        d="M62.2031 771.764C182.596 646.853 348.591 806.831 468.989 681.919"
        stroke="#F8EADD"
        stroke-width="3.68242"
        stroke-miterlimit="10"
      />
      <path
        d="M19.8506 666.611C164.267 570.495 292.015 762.427 436.429 666.312"
        stroke="#F8EADD"
        stroke-width="3.68242"
        stroke-miterlimit="10"
      />
      <path
        d="M1.10742 554.794C162.815 491.97 246.296 706.865 408.002 644.04"
        stroke="#F8EADD"
        stroke-width="3.68242"
        stroke-miterlimit="10"
      />
      <path
        d="M6.82422 441.571C178.26 414.989 213.604 642.794 385.041 616.213"
        stroke="#F8EADD"
        stroke-width="3.68242"
        stroke-miterlimit="10"
      />
      <path
        d="M36.75 332.222C209.892 343.104 195.437 573.192 368.58 584.074"
        stroke="#F8EADD"
        stroke-width="3.68242"
        stroke-miterlimit="10"
      />
      <path
        d="M89.4775 231.864C256.234 279.703 192.648 501.33 359.405 549.169"
        stroke="#F8EADD"
        stroke-width="3.68242"
        stroke-miterlimit="10"
      />
      <path
        d="M162.561 145.2C315.138 227.783 205.397 430.527 357.974 513.111"
        stroke="#F8EADD"
        stroke-width="3.68242"
        stroke-miterlimit="10"
      />
      <path
        d="M252.567 76.2661C383.819 189.719 233.064 364.13 364.315 477.583"
        stroke="#F8EADD"
        stroke-width="3.68242"
        stroke-miterlimit="10"
      />
      <path
        d="M355.276 28.2881C459.071 167.287 274.33 305.224 378.147 444.245"
        stroke="#F8EADD"
        stroke-width="3.68242"
        stroke-miterlimit="10"
      />
      <path
        d="M465.917 3.50488C537.413 161.569 327.334 256.579 398.826 414.643"
        stroke="#F8EADD"
        stroke-width="3.68242"
        stroke-miterlimit="10"
      />
      <path
        d="M579.279 3.08984C615.106 172.843 389.536 220.452 425.366 390.206"
        stroke="#F8EADD"
        stroke-width="3.68242"
        stroke-miterlimit="10"
      />
      <path
        d="M690.077 27.043C688.584 200.532 458.057 198.549 456.555 372.015"
        stroke="#F8EADD"
        stroke-width="3.68242"
        stroke-miterlimit="10"
      />
      <path
        d="M793.155 74.2827C754.406 243.391 529.684 191.886 490.936 360.994"
        stroke="#F8EADD"
        stroke-width="3.68242"
        stroke-miterlimit="10"
      />
      <path
        d="M883.649 142.548C809.458 299.368 601.038 200.762 526.848 357.582"
        stroke="#F8EADD"
        stroke-width="3.68242"
        stroke-miterlimit="10"
      />
      <path
        d="M957.361 228.705C851.193 365.905 668.844 224.809 562.676 362.008"
        stroke="#F8EADD"
        stroke-width="3.68242"
        stroke-miterlimit="10"
      />
      <path
        d="M1010.82 328.671C877.629 439.842 729.895 262.849 596.709 374.021"
        stroke="#F8EADD"
        stroke-width="3.68242"
        stroke-miterlimit="10"
      />
      <path
        d="M1041.55 437.791C887.593 517.722 781.359 313.109 627.371 393.064"
        stroke="#F8EADD"
        stroke-width="3.68242"
        stroke-miterlimit="10"
      />
      <path
        d="M1048.1 550.967C880.541 595.947 820.784 373.282 653.235 418.24"
        stroke="#F8EADD"
        stroke-width="3.68242"
        stroke-miterlimit="10"
      />
      <path
        d="M1030.19 662.922C856.884 670.829 846.375 440.511 673.069 448.419"
        stroke="#F8EADD"
        stroke-width="3.68242"
        stroke-miterlimit="10"
      />
      <path
        d="M988.596 768.375C817.647 738.842 856.903 511.659 685.954 482.125"
        stroke="#F8EADD"
        stroke-width="3.68242"
        stroke-miterlimit="10"
      />
      <path
        d="M925.336 862.44C764.737 796.848 851.906 583.406 691.307 517.814"
        stroke="#F8EADD"
        stroke-width="3.68242"
        stroke-miterlimit="10"
      />
      <path
        d="M843.304 940.711C700.548 842.128 831.565 652.409 688.837 553.826"
        stroke="#F8EADD"
        stroke-width="3.68242"
        stroke-miterlimit="10"
      />
      <path
        d="M746.377 999.524C628.151 872.56 796.892 715.441 678.694 588.478"
        stroke="#F8EADD"
        stroke-width="3.68242"
        stroke-miterlimit="10"
      />
      <path
        d="M639.083 1036.11C550.918 886.693 749.495 769.551 661.33 620.132"
        stroke="#F8EADD"
        stroke-width="3.68242"
        stroke-miterlimit="10"
      />
      <path
        d="M526.416 1048.77C472.445 883.903 691.533 812.157 637.561 647.29"
        stroke="#F8EADD"
        stroke-width="3.68242"
        stroke-miterlimit="10"
      />
      <path
        d="M213.95 621.146C222.226 621.146 228.936 614.437 228.936 606.16C228.936 597.884 222.226 591.175 213.95 591.175C205.674 591.175 198.964 597.884 198.964 606.16C198.964 614.437 205.674 621.146 213.95 621.146Z"
        fill="#F8EADD"
      />
      <path
        d="M750.763 396.752C759.046 396.752 765.77 390.033 765.77 381.744C765.77 373.454 759.046 366.735 750.763 366.735C742.471 366.735 735.756 373.454 735.756 381.744C735.756 390.033 742.471 396.752 750.763 396.752Z"
        fill="#F8EADD"
      />
    </g>
  </svg>
);

export default PlpBackground;
